import React from 'react';

import { Button } from '../../../../GlobalComponents/Button';
import { Flex } from '../../../../GlobalComponents/Flex';
import { ModalContent, ModalTitle } from './Card';

interface IConfirmationModalProps {
	title: string;
	message: React.ReactElement;
	confirmButtonText?: string;
	cancelButtonText?: string;
	showCancelButton?: boolean;
	confirmHandler: () => void;
	cancelHandler?: () => void;
	isConfirmationLoading?: boolean;
}

const ConfirmationModal = ({
	title,
	message,
	confirmButtonText = 'Confirm',
	cancelButtonText = 'Cancel',
	showCancelButton = true,
	confirmHandler,
	cancelHandler,
	isConfirmationLoading = false
}: IConfirmationModalProps): JSX.Element => {
	return (
		<ModalContent>
			<ModalTitle>{title}</ModalTitle>
			<span>{message}</span>
			<Flex
				$flexDirection="row"
				$margin="24px 0 0 0"
				$columnGap="20px"
				$placeContent="center flex-end"
			>
				{showCancelButton && (
					<Button
						type="button"
						$buttonSize={'small'}
						$backgroundColor="#757575"
						onClick={cancelHandler}
					>
						{cancelButtonText}
					</Button>
				)}
				<Button
					type="button"
					$buttonSize={'small'}
					$backgroundColor="#F47920"
					onClick={confirmHandler}
					$isLoading={isConfirmationLoading}
				>
					{confirmButtonText}
				</Button>
			</Flex>
		</ModalContent>
	);
};

export default ConfirmationModal;
